import { ProposalContent, ProposalImages } from "@/types/proposal";
import { ProposalHeader } from "./ProposalHeader";

interface ProposalPage1Props {
  content: ProposalContent;
  images: ProposalImages;
  onLogoDrop?: (dataUrl: string) => void;
}

export const ProposalPage1 = ({ content, images, onLogoDrop }: ProposalPage1Props) => {
  const titleMain = (content.title.split("—")[0] || content.title).trim();
  
  return (
    <div className="proposal-page is-page-1 avoid-break w-full mx-auto bg-white shadow-xl mb-8 print:shadow-none print:rounded-none print:mb-0 p-8 print:p-4">
      <div className="avoid-break">
        <ProposalHeader images={images} projectNumber={content.projectNumber} date={content.date} onLogoDrop={onLogoDrop} />
      </div>

      <div className="flex-1 flex flex-col justify-center items-center text-center px-8 py-12 print:py-6">
        <div className="w-full avoid-break">
          <div className="mb-8">
            <div className="text-sm font-medium text-slate-600 uppercase tracking-widest mb-4">
              CUSTOM CABINETRY PROPOSAL
            </div>
            <h1 className="text-4xl font-light text-slate-800 mb-6 leading-tight tracking-tight">
              {titleMain}
            </h1>
            <div className="w-24 h-px bg-gradient-to-r from-transparent via-amber-400 to-transparent mx-auto"></div>
          </div>

          <div className="avoid-break bg-slate-50 p-8 border-l-4 border-slate-800 text-left shadow-lg">
            <div className="grid md:grid-cols-2 gap-8 mb-6">
              <div className="text-center">
                <div className="text-3xl font-light text-slate-800 mb-2">{content.totalInvestment}</div>
                <div className="text-sm text-slate-600 uppercase tracking-wide">Investment</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-light text-slate-800 mb-2">{content.warrantyYears}</div>
                <div className="text-sm text-slate-600 uppercase tracking-wide">Year Warranty</div>
              </div>
            </div>

            <p className="text-base leading-relaxed text-slate-700 mb-4">{content.executiveSummary}</p>
            <p className="text-sm text-slate-600">{content.warrantyText}</p>
          </div>
        </div>
      </div>

      <div className="bg-slate-800 p-4 mt-auto">
        <div className="flex items-center justify-center">
          <div className="text-slate-300 text-sm tracking-widest">{content.tagline}</div>
        </div>
      </div>
    </div>
  );
};
